module.exports = __webpack_public_path__ + "static/media/kau.acdb07b6.jpeg";